import { cn } from '@/utils'
import { SquareFragment, SquareTask } from './TaskScreen'

interface FragmentGridProps {
  fragments: SquareFragment[]
  currentTask: SquareTask
  isDraggable: boolean
  placedFragmentId: string | null
  draggedFragmentId: string | null
  onDragStart: (e: React.DragEvent<HTMLDivElement>, fragmentId: string) => void
  onDragEnd: () => void
  onClick: (fragmentId: string) => void
  fragmentRefs: React.RefObject<Record<string, HTMLDivElement | null>>
}

export function FragmentGrid({
  fragments,
  currentTask,
  isDraggable,
  placedFragmentId,
  draggedFragmentId,
  onDragStart,
  onDragEnd,
  onClick,
  fragmentRefs
}: FragmentGridProps) {
  return (
    <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
      {fragments.map((fragment) => {
        const fragmentStyle = {
          width: '100%',
          height: '100px',
          backgroundImage: `url(${currentTask.imageUrl})`,
          backgroundSize: `${600}px ${400}px`,
          backgroundPosition: `-${fragment.sourceCoords.x}px -${fragment.sourceCoords.y}px`
        }

        return (
          <div
            className={cn(
              'rounded-md border p-2 transition-all',
              draggedFragmentId === fragment.id
                ? 'opacity-50 ring-2 ring-indigo-500'
                : 'opacity-100',
              placedFragmentId
                ? 'cursor-not-allowed'
                : isDraggable
                  ? 'cursor-grab active:cursor-grabbing'
                  : 'cursor-pointer hover:border-indigo-300',
              placedFragmentId === fragment.id ? 'opacity-50 ring-2 ring-green-500' : '',
              !placedFragmentId && 'hover:border-indigo-300 hover:shadow-sm'
            )}
            draggable={isDraggable && !placedFragmentId}
            key={fragment.id}
            onClick={() => onClick(fragment.id)}
            onDragEnd={onDragEnd}
            onDragStart={(e) => onDragStart(e, fragment.id)}
            ref={(el) => {
              if (fragmentRefs.current) {
                fragmentRefs.current[fragment.id] = el
              }
            }}
          >
            <div className="rounded shadow-sm" style={fragmentStyle} />
          </div>
        )
      })}
    </div>
  )
}
